module.exports = __webpack_public_path__ + "static/p_1-90202ce57173d5006518d5175686dfdb.png";